import styles from './onboarding-item.module.css';
import { IconButton } from '../button';
import { DeleteIcon } from '../icon';
import React from 'react';
import { Tooltip } from '../tooltip';

const HelpIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ verticalAlign: 'middle' }}
    >
      <rect x="1" y="1" width="30" height="30" rx="15" fill="#E2E5EA" />
      <rect
        x="1"
        y="1"
        width="30"
        height="30"
        rx="15"
        stroke="url(#paint0_linear_6071_113925)"
        strokeWidth="2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.3802 9.45508L11.6938 9.45508C12.4326 9.45507 13.0182 9.45507 13.4901 9.49334C13.9728 9.53247 14.3811 9.6141 14.754 9.80264C15.2645 10.0607 15.6943 10.4486 16.0012 10.9241C16.3082 10.4486 16.738 10.0607 17.2485 9.80264C17.6213 9.6141 18.0297 9.53247 18.5124 9.49334C18.9843 9.45507 19.5699 9.45507 20.3087 9.45508L20.6223 9.45508C20.9836 9.45507 21.2853 9.45507 21.5317 9.47504C21.7887 9.49588 22.03 9.54093 22.2581 9.6563C22.6082 9.83329 22.8928 10.1157 23.0712 10.4631C23.1874 10.6895 23.2329 10.9289 23.2538 11.184C23.274 11.4285 23.274 11.7278 23.274 12.0864V17.9007C23.274 18.2593 23.274 18.5586 23.2538 18.8031C23.2329 19.0581 23.1874 19.2976 23.0712 19.524C22.8928 19.8714 22.6082 20.1538 22.2581 20.3308C22.03 20.4461 21.7887 20.4912 21.5317 20.512C21.2853 20.532 20.9836 20.532 20.6223 20.532H19.6716C18.7927 20.532 18.4591 20.5371 18.1637 20.6262C17.8871 20.7095 17.6298 20.8461 17.4065 21.0283C17.168 21.2228 16.9786 21.4954 16.4911 22.221L16.4234 22.3218C16.3293 22.4619 16.1709 22.546 16.0012 22.546C15.8316 22.546 15.6732 22.4619 15.5791 22.3218L15.5114 22.221C15.0239 21.4954 14.8345 21.2228 14.596 21.0283C14.3727 20.8461 14.1154 20.7095 13.8388 20.6262C13.5434 20.5371 13.2097 20.532 12.3309 20.532H11.3802C11.0189 20.532 10.7172 20.532 10.4708 20.512C10.2138 20.4912 9.97252 20.4461 9.74435 20.3308C9.39428 20.1538 9.10966 19.8714 8.93129 19.524C8.81504 19.2976 8.76963 19.0581 8.74864 18.8031C8.7285 18.5586 8.72851 18.2593 8.72852 17.9007V12.0864C8.72851 11.7278 8.7285 11.4285 8.74864 11.184C8.76963 10.9289 8.81504 10.6895 8.93129 10.4631C9.10966 10.1157 9.39428 9.83329 9.74435 9.6563C9.97252 9.54093 10.2138 9.49588 10.4708 9.47504C10.7172 9.45507 11.0189 9.45507 11.3802 9.45508ZM15.4938 14.2551C15.4938 13.4948 15.4934 12.9549 15.4587 12.5324C15.4244 12.1157 15.3592 11.8578 15.2542 11.6534C15.0434 11.2428 14.707 10.9091 14.2933 10.6999C14.0873 10.5957 13.8274 10.531 13.4075 10.497C12.9817 10.4625 12.4376 10.4621 11.6714 10.4621H11.4008C11.0136 10.4621 10.7536 10.4625 10.5534 10.4787C10.3592 10.4944 10.2663 10.5226 10.2051 10.5535C10.0459 10.634 9.91656 10.7624 9.83549 10.9203C9.80427 10.9811 9.77594 11.0732 9.76006 11.266C9.74371 11.4646 9.74332 11.7225 9.74332 12.1068V17.8803C9.74332 18.2645 9.74371 18.5225 9.76006 18.7211C9.77594 18.9139 9.80427 19.006 9.83549 19.0668C9.91656 19.2247 10.0459 19.3531 10.2051 19.4335C10.2663 19.4645 10.3592 19.4926 10.5534 19.5084C10.7536 19.5246 11.0136 19.525 11.4008 19.525H12.3309C12.3586 19.525 12.3859 19.525 12.4129 19.525C13.1814 19.5248 13.6762 19.5247 14.1337 19.6626C14.5379 19.7844 14.914 19.9841 15.2404 20.2503C15.3292 20.3228 15.4126 20.4014 15.4938 20.488V14.2551ZM16.5086 20.488C16.5899 20.4014 16.6733 20.3228 16.7621 20.2503C17.0885 19.9841 17.4646 19.7844 17.8688 19.6626C18.3263 19.5247 18.8211 19.5248 19.5895 19.525C19.6165 19.525 19.6439 19.525 19.6716 19.525H20.6017C20.9889 19.525 21.2489 19.5246 21.449 19.5084C21.6433 19.4926 21.7362 19.4645 21.7974 19.4335C21.9565 19.3531 22.0859 19.2247 22.167 19.0668C22.1982 19.006 22.2266 18.9139 22.2424 18.7211C22.2588 18.5225 22.2592 18.2645 22.2592 17.8803V12.1068C22.2592 11.7225 22.2588 11.4646 22.2424 11.266C22.2266 11.0732 22.1982 10.9811 22.167 10.9203C22.0859 10.7624 21.9565 10.634 21.7974 10.5535C21.7362 10.5226 21.6433 10.4944 21.449 10.4787C21.2489 10.4625 20.9889 10.4621 20.6017 10.4621H20.3311C19.5649 10.4621 19.0208 10.4625 18.595 10.497C18.1751 10.531 17.9152 10.5957 17.7092 10.6999C17.2955 10.9091 16.9591 11.2428 16.7483 11.6534C16.6433 11.8578 16.5781 12.1157 16.5438 12.5324C16.509 12.9549 16.5086 13.4948 16.5086 14.2551V20.488Z"
        fill="#52545C"
      />
      <defs>
        <linearGradient
          id="paint0_linear_6071_113925"
          x1="0"
          y1="0"
          x2="32.3399"
          y2="28.8536"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3478D1" />
          <stop offset="1" stopColor="#A67BED" />
        </linearGradient>
      </defs>
    </svg>
  );
};

const IconContent = ({ openModal, title, description, thumbnailUrl }) => {
  return (
    <Tooltip
      title={
        <div className={styles.tooltip_container}>
          <em>{title}</em>
          <button className={styles.onboarding_button} onClick={openModal}>
            <img src={thumbnailUrl} alt={description} style={{ width: '100%' }} />
          </button>
          <p>{description}</p>
        </div>
      }
      placement={'rightTop'}
      overlayStyle={{ width: 240 }}
      zIndex={10}
    >
      <HelpIcon />
    </Tooltip>
  );
};

const BottomContent = ({ openModal, title, description, onClose, thumbnailUrl }) => {
  const onClickThumbnail = () => {
    openModal();
    onClose();
  };

  return (
    <div className={styles.container}>
      <button className={styles.onboarding_button} onClick={onClickThumbnail}>
        <img src={thumbnailUrl} alt={description} />
      </button>
      <div className={styles.description}>
        <em>{title}</em>
        <p>{description}</p>
      </div>
      <IconButton style={{ border: 'none' }} onClick={onClose}>
        <DeleteIcon />
      </IconButton>
    </div>
  );
};

export const OnboardingItem = ({
  type,
  show,
  onOpen,
  onClose,
  title,
  description,
  thumbnailUrl,
}) => {
  if (type === 'icon' && show) {
    return (
      <IconContent
        openModal={onOpen}
        title={title}
        description={description}
        thumbnailUrl={thumbnailUrl}
      />
    );
  }

  if (type === 'bottom' && show) {
    return (
      <>
        <BottomContent
          openModal={onOpen}
          title={title}
          description={description}
          onClose={onClose}
          thumbnailUrl={thumbnailUrl}
        />
      </>
    );
  }
};
